<article class="w-full h-full relative overflow-hidden">
  <app-navbar></app-navbar>

  <app-project-card-list></app-project-card-list>

  <app-footer></app-footer>
</article>